import React from 'react';
import styled from 'styled-components';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import ElementItem from './ElementItem';

const ELEMENTS = [
  {
    id: 'header',
    type: 'header',
    name: 'Header',
    icon: 'heading',
    description: 'Add a header to your email',
    defaultContent: 'Your Header Text',
    defaultStyles: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#333333',
      textAlign: 'center',
      padding: '20px'
    }
  },
  {
    id: 'text',
    type: 'text',
    name: 'Text',
    icon: 'font',
    description: 'Add a paragraph of text',
    defaultContent: 'Your content goes here. Edit this text to add your own content.',
    defaultStyles: {
      fontSize: '16px',
      color: '#333333',
      textAlign: 'left',
      padding: '10px 20px'
    }
  },
  {
    id: 'image',
    type: 'image',
    name: 'Image',
    icon: 'image',
    description: 'Add an image',
    defaultSrc: 'https://via.placeholder.com/600x200',
    defaultAlt: 'Image description',
    defaultWidth: '100%',
    defaultStyles: {
      padding: '10px',
      textAlign: 'center'
    }
  },
  {
    id: 'button',
    type: 'button',
    name: 'Button',
    icon: 'mouse-pointer',
    description: 'Add a call-to-action button',
    defaultContent: 'Click Here',
    defaultHref: '#',
    defaultStyles: {
      buttonColor: '#5876ff',
      textColor: '#ffffff',
      fontSize: '16px',
      fontWeight: 'bold',
      borderRadius: '4px',
      padding: '15px',
      textAlign: 'center'
    }
  },
  {
    id: 'spacer',
    type: 'spacer',
    name: 'Spacer',
    icon: 'arrows-alt-v',
    description: 'Add vertical space',
    defaultHeight: '20px'
  },
  {
    id: 'divider',
    type: 'divider',
    name: 'Divider',
    icon: 'minus',
    description: 'Add a horizontal line',
    defaultStyles: {
      color: '#dddddd',
      padding: '10px 0'
    }
  },
  {
    id: 'footer',
    type: 'footer',
    name: 'Footer',
    icon: 'copyright',
    description: 'Add a footer with contact info',
    defaultContent: '© 2025 Your Company. All rights reserved.',
    includeUnsubscribe: true,
    defaultStyles: {
      backgroundColor: '#f5f5f5',
      fontSize: '12px',
      color: '#666666',
      textAlign: 'center',
      padding: '20px'
    }
  }
];

const Sidebar = ({ onAddElement }) => {
  return (
    <SidebarContainer>
      <SidebarHeader>
        <h2>Elements</h2>
        <p>Click to add elements to the editor</p>
      </SidebarHeader>
      
      <ElementsList>
        {ELEMENTS.map((element, index) => (
          <ElementItem 
            key={element.id} 
            element={element} 
            onAddElement={() => onAddElement(element.type)} 
          />
        ))}
      </ElementsList>
      
      <SidebarFooter>
        <p>
          <a href="https://htmlstash.com/" target="_blank" rel="noopener noreferrer">
            HTML Stash Tools
          </a>
        </p>
      </SidebarFooter>
    </SidebarContainer>
  );
};

const SidebarContainer = styled.div`
  width: 250px;
  background-color: #f5f7fa;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const SidebarHeader = styled.div`
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  
  h2 {
    margin: 0 0 5px 0;
    font-size: 18px;
    color: #333;
  }
  
  p {
    margin: 0;
    font-size: 12px;
    color: #666;
  }
`;

const ElementsList = styled.div`
  padding: 10px;
  flex: 1;
  overflow-y: auto;
`;

const SidebarFooter = styled.div`
  padding: 15px;
  border-top: 1px solid #e0e0e0;
  text-align: center;
  
  p {
    margin: 0;
    font-size: 12px;
    
    a {
      color: #5876ff;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export default Sidebar;
